import {createStyles, makeStyles, Theme} from '@material-ui/core'
import {smBreakpoint} from '../../../utils/constants/constants'

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',

            [theme.breakpoints.down(smBreakpoint)]: {
                padding: '0 15px',
                width: '100%'
            },
        },
        text: {
            color: theme.palette.secondary.main,
            fontFamily: 'RobotoBold',
            fontSize: '1rem',
            textTransform: 'uppercase'
        },
        selected: {
            border: '1px solid #702588 !important',
            backgroundColor: 'rgba(112,37,136,0.1) !important'
        },
        selectedText: {
            color: theme.palette.primary.main,
            fontFamily: 'Roboto',
            fontWeight: 500
        },
        default: {
            backgroundColor: '#F8F8F8 !important',
            border: '1px solid #D1D5DB !important',
        },
        defaultText: {
            color: '#333333 !important',
            fontFamily: 'Roboto',
            fontWeight: 500
        },

    }),
)

export default useStyles
